import Cookies from 'js-cookie'

const TokenKey = 'SL-ClIENT-TOKEN'
const AuthKey = 'Auth-Api'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    const millisecond = new Date().getTime()
    return Cookies.set(TokenKey, token, { expires: new Date(millisecond + 2 * 60 * 60 * 1000), secure: false })
}

export function getAuthApi() {
    return Cookies.get(AuthKey)
}

export function setAuthApi(AuthApi) {
    const millisecond = new Date().getTime()
    return Cookies.set(AuthKey, AuthApi, { expires: new Date(millisecond + 2 * 60 * 60 * 1000), secure: false })
}
